import { Component, OnInit } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import { Router, ActivatedRoute } from "@angular/router";
import { BsModalService } from "ngx-bootstrap/modal";
import { FlyerImagesService } from "./flyerimages.service";
import { AlertService, BaseMaterialDatatableComponent, ConfirmDialogComponent } from "@impacgroup/angular-baselib";
import { FlyerImage } from "../../api-models/FlyerImage";
import { FlyerImagesMainComponent } from "./flyerimages.main.component";

@Component({
    selector: "app-flyerimages",
    templateUrl: "./flyerimages.component.html",
    styleUrls: ["flyerimages.component.scss"],
    standalone: false
})
export class FlyerImagesComponent extends BaseMaterialDatatableComponent<FlyerImage> implements OnInit {
    public UTCDATEFORMAT: string = "";

    rows: FlyerImage[] = [];

    constructor(
        private flyerImagesService: FlyerImagesService,
        private translateService: TranslateService,
        private router: Router,
        private route: ActivatedRoute,
        private modalService: BsModalService,
        private alertService: AlertService,
        parent: FlyerImagesMainComponent
    ) {
        super({
            stateSaveConfig: {
                stateSaveMode: flyerImagesService.datatableStateSaveMode,
                stateSaveComponent: parent,
                stateSaveStorageKey: "dtstate_organizations_list",
            },
            sortState: {
                active: "created",
                direction: "desc",
            },
            displayedColumns: ["_id", "description", "filename", "created", "updated", "actions"],
            listService: flyerImagesService,
        });

        this.UTCDATEFORMAT = this.flyerImagesService.UTCDATEFORMAT;
    }

    addFlyerImage() {
        this.router.navigate(["add"], { relativeTo: this.route });
    }

    editFlyerImage(id: string) {
        this.router.navigate([id], { relativeTo: this.route });
    }

    deleteFlyerImage(id: string) {
        const initialState = {
            title: this.translateService.instant("flyerimages.list.delete.title"),
            message: this.translateService.instant("flyerimages.list.delete.message"),
            closeBtnName: this.translateService.instant("global.buttons.close"),
            confirmBtnName: this.translateService.instant("global.buttons.ok")
        };
        const bsModalRef = this.modalService.show(ConfirmDialogComponent, { initialState });
        bsModalRef.content.confirmCallback = () => {
            this.subscriptions.push(
                this.flyerImagesService.deleteFlyerImage(id).subscribe((result) => {
                    this.alertService.addSuccess(this.translateService.instant("flyerimages.list.delete.success"));
                    this.loadData();
                })
            );
        };
    }
}
